import { ComponentContent } from "../../types/stocks";
import { getMTFList } from "../../services/TradingMallService";
import {
  textEllipsis,
  TITLE_CHAR_LIMIT,
} from "../ClpStockCards/clpCardConstant";
import { PayLaterMtfClient } from "./PayLaterMtfClinet";
import { mapMtfItemToStock } from "./PayLatermtfTypes";

interface PayLaterMtfProps {
  content?: ComponentContent;
}

export const PayLaterMtf = async ({ content }: PayLaterMtfProps) => {
  const mtfData = await getMTFList({
    page: 1,
    limit: 10,
    searchString: "",
    sort: "amount_high_to_low",
  });
  const defaultFallback = "https://cms-assets.bajajfinserv.in/is/image/bajajfinancestage/stocksplaceholder";
  const stocks = (mtfData?.mtfList ?? []).map(mapMtfItemToStock);
  const sectionTitle = textEllipsis(
    content?.componentTitle ?? "Pay later via MTF",
    TITLE_CHAR_LIMIT,
  );

  return (
    <section className="pl-4 py-3">
      <h2 className="pb-3 text-[18px] font-medium md:text-[20px]">
        {sectionTitle}
      </h2>
      <PayLaterMtfClient
        stocks={stocks}
        defaultImage={content?.defaultImageLink ?? defaultFallback}
        errorMessage={content?.stockNotFoundText}
        stockNotFoundImgUrl={content?.stockNotFoundImgUrl ?? ""}
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg}
        openInNewTab={content?.ctaInNewTab}
        href={content?.redirectLink}
        label={content?.label ?? "View all"}
        payOnly={content?.payOnly}
        sectionTitle={sectionTitle}
        componentPosition={content?.componentPosition}
      />
    </section>
  );
};
